import { createAction, createSlice, PayloadAction, } from '@reduxjs/toolkit'

const prefix = 'pages/imports'

const importsSlice = createSlice({
  name: prefix,
  initialState: {
    isOlxLoading: false as boolean,
    isOlxImportSuccess: false as boolean,
    isDomRiaLoading: false as boolean,
    isDomRiaImportSuccess: false as boolean,
  },
  reducers: {
    setIsOlxLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isOlxLoading = payload
    },
    setIsOlxImportSuccess: (state, { payload }: PayloadAction<boolean>) => {
      state.isOlxImportSuccess = payload
    },
    setIsDomRiaLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isDomRiaLoading = payload
    },
    setIsDomRiaImportSuccess: (state, { payload }: PayloadAction<boolean>) => {
      state.isDomRiaImportSuccess = payload
    },
  }
})

export const { setIsOlxLoading, setIsDomRiaLoading, setIsOlxImportSuccess, setIsDomRiaImportSuccess } = importsSlice.actions

export const startOlxImport = createAction(`${prefix}/startOlxImport`)
export const startDomRiaImport = createAction(`${prefix}/startDomRiaImport`)

export const importsReducer = importsSlice.reducer
